import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_authenticated/(sources)/wallets/',
)({
  beforeLoad: () => {
    throw redirect({
      to: '/sources',
      replace: true,
    });
  },
});
